<div id="main-nav" class="bg--navy-600" [class]="{
    'border-bottom': uiService.isMobile()
}">

    <div id="nav-side-bar" class="bg--navy-600" [class]="{
        'expanded': isExpanded()
    }">

        <div class="nav-section" [class]="{'border-bottom': !uiService.isMobile()}">
            <!-- Volta Icon -->
            <span class="volta-icon-container">
                <img class="volta-icon clickable" [src]="VoltaCommon.VOLTA_ICON" [routerLink]="['/']"/>
            </span>

            <!-- Search Icon -->
            @for (item of navData(); track $index) {
                @if(item.name == Modules.Search){
                    <app-navigation-item
                        [name]="item.name"
                        [active]="selectedIndex() == $index"
                        [isExpanded]="isExpanded()"
                        [isCurrent]="currentModule() == item.name"
                        (click)="onSelectNavItem($index)"
                    >
                        <app-navigation-module-icon [icon-colour-class]="currentModule() == item.name ? 'color--accent-primary' :'color--white-100'" [module-id]="item.id"/>
                    </app-navigation-item>
                }
            }

        </div>

        <!-- Top Module Icon -->
        <div class="nav-section flex-grow-1">

            @for (item of navData(); track $index) {

                @let itemNavigationFlag = featureFlagsService.getNavigationFlag(item.id);

                @if(
                    (itemNavigationFlag == undefined || itemNavigationFlag.visible)
                    && item.company
                    && companyService.company()
                    && (item.visibility != navigationVisibility.SearchOnly && item.visibility != navigationVisibility.Hidden)
                ) {
                    <app-navigation-item 
                        [name]="item.name"
                        [active]="selectedIndex() == $index"
                        [licensed]="itemNavigationFlag?.enabled"
                        [isExpanded]="isExpanded()"
                        [isCurrent]="currentModule() == item.name"
                        (click)="itemNavigationFlag == undefined || itemNavigationFlag.enabled != false ? onSelectNavItem($index) : undefined"
                    >
                        <app-navigation-module-icon [icon-colour-class]="currentModule() == item.name ? 'color--accent-primary' :'color--white-100'" [module-id]="item.id" [highlight]="currentModule() == item.name"/>
                    </app-navigation-item>
                }
            }
            
        </div>

        <!-- Bottom Module Icon -->
        <div class="nav-section"  [class]="{'border-bottom': !uiService.isMobile()}">
            @for (item of navData(); track $index) {

                @let itemNavigationFlag = featureFlagsService.getNavigationFlag(item.id);

                @if(
                    (itemNavigationFlag == undefined || itemNavigationFlag.visible)
                    && item.name == Modules.Management
                    && (item.visibility != navigationVisibility.SearchOnly && item.visibility != navigationVisibility.Hidden)
                ){
                    <app-navigation-item
                        [name]="item.name"
                        [active]="selectedIndex() == $index"
                        [licensed]="itemNavigationFlag?.enabled"
                        [isExpanded]="isExpanded()"
                        [isCurrent]="currentModule() == item.name"
                        (click)="itemNavigationFlag == undefined || itemNavigationFlag.enabled != false ? onSelectNavItem($index) : undefined"
                    >
                        <app-navigation-module-icon [icon-colour-class]="currentModule() == item.name ? 'color--accent-primary' :'color--white-100'" [module-id]="item.id" [highlight]="currentModule() == item.name"/>
                    </app-navigation-item>
                }
            }
        </div>

        <div class="nav-section">

            <!-- Profile Icon -->
            @for (item of navData(); track $index) {
                @if(item.name == Modules.Profile){
                    <app-navigation-item
                        [name]="item.name"
                        [active]="selectedIndex() == $index"
                        [isExpanded]="isExpanded()"
                        [isCurrent]="currentModule() == item.name"
                        (click)="onSelectNavItem($index)"
                    >
                        <app-user-image
                            [size]="'thiny'"
                            [user]="'session'"
                            [class]="{
                                'shadow-accent': currentModule() == item.name,
                                'shadow-medium-inset': currentModule() != item.name
                            }"
                       />
                    </app-navigation-item>
                }
            }

            <!-- Log Out Icon -->
            <app-navigation-item 
                [name]="'Log Out'"
                [isExpanded]="isExpanded()"
                [isCurrent]="currentModule() == 'Log Out'"
                (click)="onLogOut()"
            >
                <fa-icon [icon]="['fas', 'arrow-left-from-arc']" class="color--red-500"/>
            </app-navigation-item>

        </div>
    </div>

</div>